import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static values = {
    mode: { type: String, default: "date" }, // "date" | "time" | "datetime"
    minDate: String,
    maxDate: String,
    defaultDate: String
  }

  connect() {
    const options = this.buildOptions()
    this.picker = flatpickr(this.element, options)
  }

  disconnect() {
    this.picker?.destroy()
  }

  buildOptions() {
    const base = {
      altInput: true,
      altFormat: "j F Y",
      dateFormat: "Y-m-d",
      disableMobile: true
    }

    if (this.minDateValue) base.minDate = this.minDateValue
    if (this.maxDateValue) base.maxDate = this.maxDateValue
    if (this.defaultDateValue) base.defaultDate = this.defaultDateValue

    if (this.modeValue === "time") {
      return {
        ...base,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        altFormat: "h:i K",
        time_24hr: false
      }
    }

    if (this.modeValue === "datetime") {
      return {
        ...base,
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        altFormat: "j F Y, h:i K",
        time_24hr: false
      }
    }

    return base
  }
}